import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";

import { dirname } from "../../../util/resourcePath";

import TargetViewSummaryContent from './TargetTable/TargetViewSummaryContent';

const TargetViewSummary = (props) => {
	return (
		<div className="perf-table panel panel-default">
			<div className="panel-heading ">
				<Row>
					<Col md="12">
						<h2 className="panel-title">
							<span
								className="glyphicon glyphicon-screenshot"
								aria-hidden="true"
							></span>{" "}
							Target Table - All Sites
						</h2>
					</Col>
				</Row>
			</div>
			<TargetViewSummaryContent />
		</div>
	);
};

export default TargetViewSummary
